import { Chart } from "chart.js";


if ($("#status-chart").length) {
    $.ajax({
        url: "/condominio/status", success: function (result) {
            //console.log(JSON.parse(result)[0]);
            const itens = JSON.parse(result);
            new Chart($("#status-chart"), {
                type: 'bar',

                data: {
                    labels: [""],
                    datasets: [{
                        label: ["Atualizada"],
                        backgroundColor: ["#013B9B"],
                        data: [itens[0]],
                    },
                    {
                        label: ["Atenção"],
                        backgroundColor: "#F7A40F",
                        data: [itens[1]],
                    },
                    {
                        label: ["Atrasada"],
                        backgroundColor: "#c0392b",
                        data: [itens[2]],
                    }
                    ]
                },
                options: {
                    plugins: {
                        title: {
                            display: false,
                            text: 'Manutenção que foram realizadas em atenção ou atrasadas'
                        },

                    },

                    responsive: false,
                    maintainAspectRatio: false,
                    aspectRatio: 1
                }
            });

        }
    });

    $.ajax({
        url: "/condominio/previstfinish", success: function (result) {
            const itens = JSON.parse(result);

            new Chart($("#previst-finish-chart"), {
                type: 'line',
                data: {
                    labels: itens.map(item => item.month),
                    datasets: [{
                        data: itens.map(item => item.previst),
                        label: "Previsto",
                        borderColor: "#3e95cd",
                        backgroundColor: "#3e95cd",
                        fill: false
                    }, {
                        data: itens.map(item => item.finish),
                        label: "Realizado",
                        borderColor: "#55cd38",
                        backgroundColor: "#55cd38",
                        fill: false
                    }]
                },
                options: {
                    plugins: {
                        title: {
                            font: {
                                size: '20px'
                            },
                            display: true,
                            padding: 10,
                            text: 'Manutenções previstas comparadas com as realizadas'
                        },
                        subtitle: {
                            display: true,
                            padding: 0,
                            text: 'Comparativo das manutenções previstas e realizadas em cada um dos meses, gráfico atualizado automaticamente'
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 1
                }
            });
        }
    });


    $.ajax({
        url: "/condominio/level", success: function (result) {
            //console.log(JSON.parse(result)[0]);
            const itens = JSON.parse(result);
            console.log(itens);

            new Chart($("#level-condominio-chart"), {
                type: 'bar',
                data: {
                    labels: itens.titles,
                    datasets: [{
                        label: "Últimas notas",
                        backgroundColor: "#3536ff",
                        // backgroundColor: [getRandomColor(), getRandomColor(),getRandomColor(),getRandomColor(),getRandomColor()],
                        data: itens.values

                    }]
                },
                options: {
                    plugins: {
                        title: {
                            display: true,
                            text: 'Notas dos Condomínios baseado nas manutenções'
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                }
            });


        }
    });
}

if ($("#status-chart-manager").length) {
    // Gestores de grupo

    $.ajax({
        url: "/condominio/statusmanager", success: function (result) {
            //console.log(JSON.parse(result)[0]);
            const itens = JSON.parse(result);
            console.log(itens);

            new Chart($("#status-chart-manager"), {
                type: 'pie',

                data: {
                    labels: ["Atualizada", "Atenção", "Atrasada"],
                    datasets: [{
                        label: "MANUTENÇÃO GERAL",
                        backgroundColor: ["#55cd38", "#F2AC29", "#D90B1C"],
                        data: itens,
                    }]
                },
                options: {
                    plugins: {
                        title: {
                            display: true,
                            text: 'Manutenção que foram realizadas em atenção ou atrasadas'
                        }
                    },

                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 1
                }
            });

        }
    });

    $.ajax({
        url: "/condominio/levelmanager", success: function (result) {
            //console.log(JSON.parse(result)[0]);
            const itens = JSON.parse(result);
            console.log(itens);

            new Chart($("#level-condominio-chart-manager"), {
                type: 'bar',
                data: {
                    labels: itens.titles,
                    datasets: [{
                        label: "Últimas notas",
                        backgroundColor: "#3536ff",
                        // backgroundColor: [getRandomColor(), getRandomColor(),getRandomColor(),getRandomColor(),getRandomColor()],
                        data: itens.values

                    }]
                },
                options: {
                    plugins: {
                        title: {
                            display: true,
                            text: 'Notas dos Condomínios baseado nas manutenções'
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                }
            });


        }
    });
    $.ajax({
        url: "/condominio/previstfinishmanager", success: function (result) {
            //console.log(JSON.parse(result)[0]);
            const itens = JSON.parse(result);

            new Chart($("#previst-finish-chart-manager"), {
                type: 'line',
                data: {
                    labels: [itens[0].month, itens[2].month, itens[3].month, itens[4].month, itens[5].month, itens[6].month, itens[7].month, itens[8].month, itens[9].month, itens[10].month, itens[11].month],
                    datasets: [{
                        data: [itens[0].previst, itens[2].previst, itens[3].previst, itens[4].previst, itens[5].previst, itens[6].previst, itens[7].previst, itens[8].previst, itens[9].previst, itens[10].previst, itens[11].previst],
                        label: "Previsto",
                        borderColor: "#3e95cd",
                        backgroundColor: "#3e95cd",
                        fill: false
                    }, {
                        data: [itens[0].finish, itens[2].finish, itens[3].finish, itens[4].finish, itens[5].finish, itens[6].finish, itens[7].finish, itens[8].finish, itens[9].finish, itens[10].finish, itens[11].finish],
                        label: "Realizado",
                        borderColor: "#55cd38",
                        backgroundColor: "#55cd38",
                        fill: false
                    }
                    ]
                },
                options: {
                    plugins: {
                        title: {
                            display: true,
                            text: 'Manutenções previstas comparadas com as realizadas'
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 1
                }
            });


        }
    });

    $.ajax({
        url: "/condominio/statusclientmanager", success: function (result) {
            //console.log(JSON.parse(result)[0]);
            const itens = JSON.parse(result);

            new Chart($("#status-condominio-chart-manager"), {
                type: 'bar',
                data: {
                    labels: itens.client,
                    datasets: [
                        {
                            label: "Atualizada",
                            backgroundColor: "#55cd38",
                            data: itens.finish
                        }, {
                            label: "Atenção",
                            backgroundColor: "#F2AC29",
                            data: itens.padding
                        },
                        {
                            label: "Atrasado",
                            backgroundColor: "#D90B1C",
                            data: itens.lost
                        }
                    ]
                },
                options: {
                    plugins: {
                        title: {
                            display: true,
                            text: 'Manutenções Atualizadas, em atenção e realizadas por Condomínio '
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 1
                }
            });


        }
    });


}

function getRandomColor() {
    const letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
